import { useReveal } from "@/hooks/useReveal";
import { APP_URL } from "@/lib/constants";
import { AiTryOnDemo } from "@/components/landing/AiTryOnDemo";
import { trackEvent } from "@/lib/analytics";

const STEPS = [
  "Загрузите фотографию.",
  "Выберите модель.",
  "Через несколько секунд увидите, как она выглядит именно на вас.",
];

export const AiFitting = () => {
  const ref = useReveal();
  return (
    <section id="fitting" ref={ref} data-testid="fitting-section" className="py-28 md:py-36" style={{ background: "var(--paper)" }}>
      <div className="pw-container">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div>
            <span className="pw-eyebrow reveal">ИИ-примерка</span>
            <h2 className="pw-h2 reveal mt-6">Ваша примерка начинается дома.</h2>
            <div className="mt-10 space-y-6">
              {STEPS.map((s, i) => (
                <div key={i} data-testid={`fitting-step-${i}`} className="reveal flex items-start gap-5" style={{ transitionDelay: `${i * 100}ms` }}>
                  <span
                    className="shrink-0 w-9 h-9 rounded-full flex items-center justify-center text-[13px] font-semibold text-white"
                    style={{ background: "var(--ink-2)" }}
                  >
                    {i + 1}
                  </span>
                  <p className="text-base md:text-lg font-medium pt-1.5" style={{ letterSpacing: "-0.01em" }}>
                    {s}
                  </p>
                </div>
              ))}
            </div>
            <p className="reveal mt-9 text-base" style={{ color: "var(--grey-1)" }}>
              Без поездки в бутик. Без сомнений.
            </p>
            <a
              href={APP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="fitting-cta"
              onClick={() => {
                trackEvent("ai_fitting_start", { location: "fitting_section" });
                trackEvent("app_click", { location: "ai_fitting" });
              }}
              className="pw-btn pw-btn-dark btn-ingot reveal mt-9"
            >
              <span className="ingot-inner">
                <span className="ingot-label">Попробовать ИИ-примерку</span>
                <span className="ingot-brand" aria-hidden="true">Angiolini</span>
              </span>
            </a>
          </div>

          <div className="reveal">
            <AiTryOnDemo />
          </div>
        </div>
      </div>
    </section>
  );
};
